<template>
  <HeaderComponent />
  <NavigationComponent :alwaysShowLogo="true" />
  <div class="container mx-auto px-4 py-16 text-center">
    <h1 class="text-4xl font-bold font-orbitron mb-4">Page not found</h1>
    <p class="text-lg font-roboto text-gray-700">
      That address does not exist. It may have moved, or the link may be out of date.
    </p>
    <div class="mt-8 flex flex-wrap justify-center gap-4">
      <router-link to="/" class="btn-primary">Back to the homepage</router-link>
      <router-link to="/contact" class="btn-secondary">Contact us</router-link>
    </div>
  </div>
  <FooterComponent />
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import NavigationComponent from '@/components/NavigationComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  name: 'NotFoundPage',
  components: {
    HeaderComponent,
    NavigationComponent,
    FooterComponent
  }
};
</script>
